import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-video-instructions',
  templateUrl: './video-instructions.component.html',
  styleUrls: ['./video-instructions.component.scss'],
  standalone: false
})
export class VideoInstructionsComponent {
  @Input() videoWidth: number = 0;
  readonly ttsText = 'Video Settings. Tap the arrow for video options. Watch in full screen. Change speed or language. Turn on subtitles.';


  calcVideoWidth(width: number): number | null {
    let returnWidth = width > 0 ? width : null;
    // videoWidth > 0 ? videoWidth - 20 : null
    if (width) {
      switch (true) {
        case width > 600:
        case width > 450:
          returnWidth = width - 40;
          break;
        case width > 300:
          returnWidth = width - 30;
          break;
        case width < 250:
          returnWidth = width - 20;
          break;
      }
    }
    return returnWidth;
  }
}
